import React from "react";
import {whatsappUrl} from "../utils/format";
import {WhatsAppIcon} from "./icons";

/**
 * A phone number as shown to the user. Numbers in international format
 * ("+55 11 99999-9999") link to WhatsApp; anything else stays plain text.
 *
 * @param {{phone?: string|null}} props
 */
const PhoneLink = ({phone}) => {
    if (!phone) return null;
    const url = whatsappUrl(phone);
    if (!url) return <>{phone}</>;
    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir no WhatsApp"
            className="text-decoration-none text-nowrap"
        >
            <span className="me-1" style={{color: "#25D366"}}>
                <WhatsAppIcon />
            </span>
            {phone}
        </a>
    );
};

export default PhoneLink;
